module.exports = __webpack_public_path__ + "img/AntMalllogo.1dfc965e.svg";